const ENVIRONMENTS = {
  FIREBASE: {
    API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    DATABASE_URL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  },
  API_DIGITAL_TICKET: {
    BASE_URL: process.env.REACT_APP_API_DIGITAL_TICKET_BASE_URL,
    ITINERARY_CAPACITY_API: process.env.REACT_APP_ITINERARY_CAPACITY_BASE_URL,
    CODE: process.env.REACT_APP_API_DIGITAL_TICKET_CODE,
    OCP_APIM: {
      SUBSCRIPTION_KEY:
        process.env.REACT_APP_API_DIGITAL_TICKET_OC_APIM_SUBSCRIPTION_KEY,
      TRACE: process.env.REACT_APP_API_DIGITAL_TICKET_OC_APIM_TRACE,
    },
  },
  ATTENDANCE: {
    WEBSOCKET_URL: process.env.REACT_APP_AWS_WEBSOCKET_URL,
    BASE_URL: process.env.REACT_APP_AWS_BASE_URL,
    BASE_URL_2: process.env.REACT_APP_AWS_BASE_URL_2,
    REACT_APP_ATTENDANCE_KEY: process.env.REACT_APP_ATTENDANCE_KEY,
    REACT_APP_ATTENDANCE_PLAN: process.env.REACT_APP_ATTENDANCE_PLAN,
  },
  GOOGLE: {
    RECAPTCHA_SITE_KEY: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
    MAP_KEY: process.env.REACT_APP_GOOGLE_MAP_KEY,
    MAP_URL: process.env.REACT_APP_GOOGLE_MAP_URL,
  },
  CEP: {
    BASE_URL: process.env.REACT_APP_CEP_BASE_URL,
    APP_KEY: process.env.REACT_APP_CEP_APP_KEY,
    APP_SECRET: process.env.REACT_APP_CEP_APP_SECRET,
  },
  CID: {
    BASE_URL: process.env.REACT_APP_CID_BASE_URL,
  },
  AWS_IOT: {
    IDENTITY_POOL_ID: process.env.REACT_APP_AWS_IOT_IDENTITY_POOL_ID,
    REGION: process.env.REACT_APP_AWS_IOT_REGION,
    USER_POOL_ID: process.env.REACT_APP_AWS_IOT_USER_POOL_ID,
    MQTT_ID: process.env.REACT_APP_AWS_IOT_MQTT_ID,
    USER_POOL_WEB_CLIENT_ID:
      process.env.REACT_APP_AWS_IOT_USER_POOL_WEB_CLIENT_ID,
    TOPIC: process.env.REACT_APP_AWS_IOT_TOPIC,
  },
  OSRM: {
    BASE_URL: process.env.REACT_APP_OSRM_BASE_URL,
  },
  TICKET_SALES: {
    TICKET_SALES_URL: process.env.REACT_APP_TICKET_SALES_URL,
    RESCHEDULE_TAXE: process.env.REACT_APP_TICKET_SALES_RESCHEDULE_TAXE,
    AUTH_3DS_URL: process.env.REACT_APP_TICKET_SALES_AUTH_3DS_URL,
    AUTH_3DS: process.env.REACT_APP_TICKET_SALES_AUTH_3DS,
    PAYMENT_METHODS:
      process.env.REACT_APP_TICKET_SALES_AVAILABLE_PAYMENT_METHODS,
    ADYEN_CLIENT_KEY: process.env.REACT_APP_TICKET_SALES_ADYEN_CLIENT_KEY,
    ADYEN_PAYMENT: process.env.REACT_APP_TICKET_SALES_ADYEN_PAYMENT,
    ITINERARY_TYPE: process.env.REACT_APP_TICKET_SALES_ITINERARY_TYPE,
  },
  VT: {
    TOLL_ROUND: process.env.REACT_APP_TOLL_ROUND,
    VT_PRINT: process.env.REACT_APP_CUSTOM_VT_PRINT,
  },
  ALGOLIA_PLACES_URL: process.env.REACT_APP_ALGOLIA_PLACES,
  HERE_URL: process.env.REACT_APP_HERE_URL,
  HERE_API_KEY: process.env.REACT_APP_HERE_API_KEY,
  PASSWORD_REDIRECT: process.env.REACT_APP_PASSWORD_REDIRECT,
  PAYMENT_TYPES: process.env.REACT_APP_PAYMENT_METHODS_FOR_COMPANY_ORDERS,
  INVOICE_CONTAINER: process.env.REACT_APP_CONTAINER,
  OPERATOR_CONTAINER: process.env.REACT_APP_OPERATOR_CONTAINER,
  CITY: process.env.REACT_APP_CITY,
  OPERATOR: process.env.REACT_APP_OPERATOR,
  IMPORT_TYPE: process.env.REACT_APP_IMPORT_TYPE,
  OPERATOR_ID: process.env.REACT_APP_OPERATOR_ID,
  COMPANY_NAME: process.env.REACT_APP_COMPANY_NAME,
  NEW_LIVE_MONITORING_LIST: process.env.REACT_APP_NEW_LIVE_MONITORING_LIST,
  EXTERNAL_REPORTS: process.env.REACT_APP_EXTERNAL_REPORTS,
  HAS_ORDER_IMPORT: process.env.REACT_APP_HAS_ORDER_IMPORT,
  FACIAL_CONFIG: process.env.REACT_APP_FACIAL_CONFIG,
  IGNORE_CONFLICT_RESTRICTION:
    process.env.REACT_APP_IGNORE_CONFLICT_RESTRICTION,
  DISABLE_EDIT_FIELDS_FOR_SELLING_TERMINAL:
    process.env.REACT_APP_DISABLE_EDIT_FIELDS_FOR_SELLING_TERMINAL,
  REACT_APP_NO_CACHE_EXTERNAL_REPORT:
    process.env.REACT_APP_NO_CACHE_EXTERNAL_REPORT,
  XML_RETRIES: process.env.REACT_APP_XML_RETRIES,
};

export default ENVIRONMENTS;
